import { render, staticRenderFns } from "./TaskAdd.vue?vue&type=template&id=605f9f6c&scoped=true"
import script from "./TaskAdd.vue?vue&type=script&lang=js"
export * from "./TaskAdd.vue?vue&type=script&lang=js"
import style0 from "./TaskAdd.vue?vue&type=style&index=0&id=605f9f6c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605f9f6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('605f9f6c')) {
      api.createRecord('605f9f6c', component.options)
    } else {
      api.reload('605f9f6c', component.options)
    }
    module.hot.accept("./TaskAdd.vue?vue&type=template&id=605f9f6c&scoped=true", function () {
      api.rerender('605f9f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-task/TaskAdd.vue"
export default component.exports